
import { mapGetters, mapActions } from 'vuex';
import { formatData } from "../../../constants/config.js";
import moment from "moment";
export default {
    components: {
        vcLoading   : () => import('../../../components/pages/loading.vue'),
        breadcrumbs : () => import('../../../components/pages/breadcrumbs.vue'),
        basicTable  : () => import('../../../components/pages/basic-table.vue')
    },
    data() {
        return {
            isLoagingPage: null,
            data_order: null
        };
    },
    async mounted(){
        
        this.$root.$on('open-sidebar-orders', this.openSideBarOrder);
    },
    computed: {
        ...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang',
            getterOrder     : 'getterOrder'
        }),
        getTableFields(){
            return [
            { key: 'created_at', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.date[this.getterStoreLang], class: "w-15", formatter: (value, key, item) => { 
                return moment(value.toString().split(".")[0]).format('lll'); 
            } },
            { key: 'name', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.order_number[this.getterStoreLang], class: "w-15" },
            { key: 'quantity_items', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.items[this.getterStoreLang], class: "w-15 d-md-table-cell d-none text-center" },
            { key: 'total_price', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.total[this.getterStoreLang], class: "w-15 d-md-table-cell d-none", formatter: (value, key, item) => { 
                return this.formatCurrency(value).format; 
            } },
            { key: 'financial_status', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.status_order[this.getterStoreLang], class: "w-15 d-none d-sm-table-cell" },
            { key: 'fulfillments', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.status_shipping[this.getterStoreLang], class: "w-15 d-none d-sm-table-cell" },
            { key: 'actions', label: this.getterTranslates.pages.account.dashboard.my_orders.table_fields.actions[this.getterStoreLang], class: "w-10 hide-title" }
            ];
        },
        getDataOrder(){
            return this.data_order;
        },
        getLoagingPage(){
            return this.isLoagingPage;
        }
    },
    methods: {
        ...mapActions({
            getOrder: 'getOrder'
        }),
        formatCurrency(value){
            return formatData.currency(value);
        },
        async openSideBarOrder(data) {
            
            this.isLoagingPage = true;
            await this.getOrder({ name: data.name }).then(() => {
                
                if( this.getterOrder != null ){
                    
                    this.data_order = this.getterOrder;
                    this.$refs.orderDetails.show();
                };
                this.isLoagingPage = null;
            });
        },
        hideModal() {
            this.$refs.orderDetails.hide();
            this.data_order = null;
        },
    }
}
